import { CurrencyFragment } from "@lana-commerce/core/graphql/types";

export const formatCurrencyLabel = (c: CurrencyFragment) => `${c.currency.name} [${c.currency.code}]`;
